export const completedSteps = [
  'Tell us about you',
  'Create Workspaces',
  'Add Discussion Topics',
  'Give Kudos',
  'Meet Manager Assistant',
];
